@if (validating || saving) {
  <div>
    <div class="flex-container-center margin-bottom-15">
      <mat-spinner></mat-spinner>
    </div>
    @if (validating) {
      <div class="flex-container-center">
        {{ 'orders.validating' | transloco }}
      </div>
    }
    @if (saving) {
      <div class="flex-container-center">
        {{ 'orders.saving' | transloco }}
      </div>
    }
  </div>
}

<div [@slideDown]="shouldShowForm() ? 'visible' : 'hidden'">
  <lib-static-notice
  [text]="'orders.theProvidedCriteriaIsNotValid' | transloco"></lib-static-notice>
  <form [formGroup]="ordersForm">
    <div formArrayName="orders">
      @for (entry of data; track entry; let i = $index) {
        <div [formGroupName]="i">
          <h4>{{ entry.data.order.displayJurisdiction }} ({{
          entry.data.order.jurisdiction }})</h4>
          @if (entry.data.order.orderTypeID === 'AssetSearch') {
          <div class="flex-container">
            <div class="validated-form-field-container flex-container">
              <mat-form-field class="flex-item form-field" appearance="outline">
                <mat-label>{{ 'common.labels.serialNumber' | transloco }}</mat-label>
                <input matInput formControlName="serialNumber" name="serial-number"
                  [placeholder]="'common.labels.serialNumber' | transloco">
              </mat-form-field>
              <lib-error-bubble [control]="getSerialNumberControl(entry.id)"
                [message]="getSerialNumberErrorSubject(entry.id)"
                [showErrorsOnLoad]="true"></lib-error-bubble>
            </div>
          </div>
          } @else if (entry.data.order.orderTypeID === 'DebtorSearch') {
          <div class="flex-container">
            @if (entry.data.order.parties?.at(0)?.partyTypeID === 'IndividualDebtor') {
            <div class="validated-form-field-container flex-container">
              <mat-form-field class="flex-item form-field" appearance="outline">
                <mat-label>{{ 'common.labels.firstName' | transloco }}</mat-label>
                <input matInput formControlName="firstName" name="first-name" [placeholder]="'common.labels.firstName' | transloco">
              </mat-form-field>
              <lib-error-bubble [control]="getFirstNameControl(entry.id)"
                [message]="getFirstNameErrorSubject(entry.id)" [showErrorsOnLoad]="true"></lib-error-bubble>
            </div>
            <div class="validated-form-field-container flex-container">
              <mat-form-field class="flex-item form-field" appearance="outline">
                <mat-label>{{ 'common.labels.middleName' | transloco }}</mat-label>
                <input matInput formControlName="middleName" name="middle-name" [placeholder]="'common.labels.middleName' | transloco">
              </mat-form-field>
              <lib-error-bubble [control]="getMiddleNameControl(entry.id)"
                [message]="getMiddleNameErrorSubject(entry.id)" [showErrorsOnLoad]="true"></lib-error-bubble>
            </div>
            <div class="validated-form-field-container flex-container">
              <mat-form-field class="flex-item form-field" appearance="outline">
                <mat-label>{{ 'common.labels.lastName' | transloco }}</mat-label>
                <input matInput formControlName="lastName" name="last-name" [placeholder]="'common.labels.lastName' | transloco">
              </mat-form-field>
              <lib-error-bubble [control]="getLastNameControl(entry.id)"
                [message]="getLastNameErrorSubject(entry.id)" [showErrorsOnLoad]="true"></lib-error-bubble>
            </div>
            } @else if (entry.data.order.parties?.at(0)?.partyTypeID === 'BusinessDebtor') {
            <div class="validated-form-field-container flex-container">
              <mat-form-field class="flex-item form-field" appearance="outline">
                <mat-label>{{ 'common.labels.businessName' | transloco }}</mat-label>
                <input matInput formControlName="busName" name="bus-name" [placeholder]="'common.labels.businessName' | transloco">
              </mat-form-field>
              <lib-error-bubble [control]="getBusNameControl(entry.id)"
                [message]="getBusNameErrorSubject(entry.id)" [showErrorsOnLoad]="true"></lib-error-bubble>
            </div>
            }
          </div>
          @if (entry.data.order.parties?.at(0)?.partyTypeID === 'IndividualDebtor') {
          <div class="flex-container">
            <div class="validated-form-field-container flex-container">
                <mat-form-field
                  class="form-field flex-item" appearance="outline">
                  <mat-label>{{ 'orders.birthDate' | transloco }}</mat-label>
                  <input matInput [matDatepicker]="dateOfBirth" formControlName="dateOfBirth" name="date-of-birth"
                    [placeholder]="'common.labels.yyyyMmDd' | transloco">
                  <mat-datepicker-toggle matSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
                  <mat-datepicker #dateOfBirth></mat-datepicker>
                </mat-form-field>
              <lib-error-bubble [control]="getDateOfBirthControl(entry.id)"
              [message]="getDateOfBirthErrorSubject(entry.id)" [showErrorsOnLoad]="true"></lib-error-bubble>
            </div>
          </div>
          }
          }
        </div>
      }
    </div>
  </form>
</div>

@if (!shouldShowForm() && !validating && !saving) {
  <div class="padding">
    <lib-placeholder iconName="check_circle" iconClass="icon-success" [message]="'orders.noInvalidCriteria' | transloco"
    [condition]="true"></lib-placeholder>
  </div>
}